import React from 'react';
import {Button} from "primereact/button";
import {useTranslate} from "../../system/useTranslate";

function PageHeader({title, description, backButton, descriptionClassName, titleClassName}) {
    const translate = useTranslate();
    return (
        <div className="flex align-items-center w-full p-3 pt-0 pb-0">
            {backButton}
            <div>
                <h1 className={`m-0 ${titleClassName}`}>{translate(title)}</h1>
                <span className={`text-400 ${descriptionClassName}`}>{translate(description)}</span>
            </div>
        </div>


    );
}

export default PageHeader;